<template>
    <div>
        <div class="pop_container4">
            <div class="pop_title">{{obj.name}}</div>

            <div class="monitor_video_1">
                <div class="monitor_video_top">
                    <img src="@/assets/img/img_monitor_point.png">
                    <div class="photographic_txt2">在线</div>
                     <img src="@/assets/img/shut.png" @click="closeWin()">
                </div>
                <div class="monitor_video_bottom">
                    <div class="monitor_pic">
                        <div class="forVideo" style="display: flex;flex-flow: row wrap;" id="open"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Swiper from "@/assets/js/swiper.min.js";
    import imosSdk from 'imosSdk'
    import $ from 'jquery'

    // var iframeObj;
    export default {
        props: {},
        data() {
            return {
                obj:{},
                iframeObj:null
            };
        },
        components: {},
        mounted() {
        },
        watch: {
            obj: {
                deep: true,
                handler: function (val) {
                    this.creatWindow(val.cameraCode);
                },
            },
        },

        created() {
            var that = this;
            this.$bus.$on('brotherEvent', res=>{
                that.obj=res;
                console.log(res) // 得到123
            })
        },
        methods: {
            closeWin(){
                if (this.$parent.isOpenDialog4) {
                    this.$parent.isOpenDialog4 = false;
                } else {
                    this.$parent.isOpenDialog4 = true;
                }
            },
            creatWindow(cameraCode) {
                if (!window.token) {
                    console.log("请先登录")
                    return;
                }
                var iframeObj = imosSdk.createPanelWindow();

                if (iframeObj === null) {
                    return;
                }
                $("#open").empty();
                $("#open").append(iframeObj);
                $("#open .imosSdk-video").css("width", "1046px");
                $("#open .imosSdk-video").css("height", "600px");

                this.playLive(iframeObj.id, cameraCode);
            },
            playLive(iframeId, cameraCode) {
                if (!window.token) {
                    console.log("请先登录")
                    return;
                }
                imosSdk.playLive(
                    iframeId,
                    cameraCode,
                    cameraCode,
                    function (e) {
                        console.log(e);
                    }, 1
                );
                cameraCode = null;
            },
        },
    };

</script>
<style scoped src="@/assets/css/pop2.css"></style>